import * as React from 'react';
import PropTypes from 'prop-types';
import { RootContext, UserApiV1InstitutionMenusPath } from '../../../index';

export default class Menus extends React.Component {
  static contextType = RootContext;

  componentDidMount () {
    const ids = location.pathname.split('/').filter(s => s !== '').slice(-2);
    this.context.showLoading();
    this.context.fetch(UserApiV1InstitutionMenusPath(ids[0])).then(body => {
      this.setState({ menus: body.results });
    }).finally(() => {
      this.context.hideLoading();
    });
  }

  onClickMenu (url) {
    location.href = url;
  }

  render () {
    return (
      <div className="p-container p-menus">
        <div className="l-conatiner">
          <h4 className="w90p c-mn-title-2 ta-c">{this.context.t('Menus.select_treatment_menu')}</h4>
          {this.state?.menus?.map(menu => {
            return (
              <a key={menu.id} className="c-mn-card my-lg mx-16px" onClick={ () => { this.onClickMenu(menu.url_location.show); } }>
                <div className="c-mn-card-contents">
                  <div className="c-mn-card-main">
                    <div className="c-mn-card-contents__name">
                      <p>{menu.title}</p>
                    </div>
                  </div>
                </div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.21 21.36" className="c-mn-icon-arrow"><path d="M1.5,21.36A1.49,1.49,0,0,1,0,19.86,1.47,1.47,0,0,1,.45,18.8l8.26-8.12L.45,2.57A1.47,1.47,0,0,1,0,1.51,1.46,1.46,0,0,1,.44.44,1.5,1.5,0,0,1,1.5,0a1.47,1.47,0,0,1,1,.43l9.13,9a1.74,1.74,0,0,1,.53,1.25,1.72,1.72,0,0,1-.53,1.24l-9.13,9A1.47,1.47,0,0,1,1.5,21.36Z" className="c-c-icon-arrow-path"></path></svg>
              </a>
            );
          })}
        </div>
      </div>
    );
  }
}

Menus.propTypes = {
  menus: PropTypes.object,
  url_location: PropTypes.object,
};
